import { render } from "./PpmUspWorkDetailDialog.vue?vue&type=template&id=5b844c26&scoped=true"
import script from "./PpmUspWorkDetailDialog.vue?vue&type=script&lang=js"
export * from "./PpmUspWorkDetailDialog.vue?vue&type=script&lang=js"

import "./PpmUspWorkDetailDialog.vue?vue&type=style&index=0&id=5b844c26&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b844c26"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QIcon,QSpace,QBtn,QSpinner,QMarkupTable});qInstall(script, 'directives', {ClosePopup});
